import { render, staticRenderFns } from "./Dzialanie.vue?vue&type=template&id=663489ff&"
import script from "./Dzialanie.vue?vue&type=script&lang=js&"
export * from "./Dzialanie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports